
const state = {
    companyCategoriesList: []
}
const getters = {
    getCompanyCategoriesList(state) {
        return state.companyCategoriesList
    },

    getCompanyCategoryById(state) {
        return (id) => state.companyCategoriesList.find(companyCategory => companyCategory.value == id)
    }
}
const mutations = {
    SET_COMPANY_CATEGORIES_LIST(state, newCompanyCategoriesList) {
        state.companyCategoriesList = newCompanyCategoriesList
    }
}
const actions = {
    setCompanyCategoriesList(context, newCompanyCategoriesList) {
        const newCompanyCategoriesListMapped = newCompanyCategoriesList.map(companyCategory => {
            return { value: companyCategory.id, text: companyCategory.name }
        })
        context.commit('SET_COMPANY_CATEGORIES_LIST', newCompanyCategoriesListMapped)
    }
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}